"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlaneIcon = require("./PlaneIcon");

var _PlaneIcon2 = _interopRequireDefault(_PlaneIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PlaneIcon2.default;